import { Facebook, Instagram, Twitch, Youtube } from "lucide-react";
import { SOCIALS } from "@/lib/brand";

const SoundCloud = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M1 14.5c0-.3.2-.5.5-.5s.5.2.5.5v2.5c0 .3-.2.5-.5.5S1 17.3 1 17v-2.5Zm2-1.5c0-.3.2-.5.5-.5s.5.2.5.5v4c0 .3-.2.5-.5.5S3 17.3 3 17v-4Zm2-1c0-.3.2-.5.5-.5s.5.2.5.5v5c0 .3-.2.5-.5.5S5 17.3 5 17v-5Zm2-1.5c0-.3.2-.5.5-.5s.5.2.5.5V17c0 .3-.2.5-.5.5S7 17.3 7 17v-6.5Zm2-1c0-.3.2-.5.5-.5s.5.2.5.5V17c0 .3-.2.5-.5.5S9 17.3 9 17V9.5Zm2-1.3c0-.4.2-.6.6-.8A6 6 0 0 1 19.9 12 3 3 0 1 1 20 17.5h-8.4c-.3 0-.6-.3-.6-.6V8.2Z" />
  </svg>
);

const ICONS = { instagram: Instagram, youtube: Youtube, soundcloud: SoundCloud, twitch: Twitch, facebook: Facebook };

export const SocialLinks = () => (
  <div className="flex gap-3 mt-6" data-testid="footer-socials">
    {SOCIALS.map(({ key, label, href }) => {
      const Icon = ICONS[key];
      return (
        <a key={key} href={href} target="_blank" rel="noreferrer" aria-label={label} title={label}
          className="w-10 h-10 grid place-items-center border border-white/15 text-zinc-300 hover:text-white hover:border-primary hover:bg-primary transition-colors"
          data-testid={`footer-social-${key}`}>
          <Icon className="w-4 h-4" />
        </a>
      );
    })}
  </div>
);
